'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ipfs-unixfs'),
    UnixFS = _require.UnixFS;

var persist = require('../utils/persist');

var _require2 = require('ipld-dag-pb'),
    DAGNode = _require2.DAGNode;
/**
 * @typedef {import('../types').Directory} Directory
 */

/**
 * @type {import('../types').UnixFSV1DagBuilder<Directory>}
 */


var dirBuilder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, block, options) {
    var unixfs, buffer, cid, path;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            unixfs = new UnixFS({
              type: 'directory',
              mtime: item.mtime,
              mode: item.mode
            });
            buffer = new DAGNode(unixfs.marshal()).serialize();
            _context.next = 4;
            return persist(buffer, block, options);

          case 4:
            cid = _context.sent;
            path = item.path;
            return _context.abrupt("return", {
              cid: cid,
              path: path,
              unixfs: unixfs,
              size: buffer.length
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function dirBuilder(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = dirBuilder;